import React from "react";
import styles from "./layout.module.scss";

const Button = (props) => (
  <button className={`${styles.button} ${props.dark ? styles.buttonDark : ''}`}>
    {props.children}
  </button>
);

export default Button;

